

interface SaveNewPhrasesParams {
  /** Whether the app is running in a numbered development environment */
  isNumberedDevEnvironment: boolean;

  /** Whether the app is running on localhost */
  isLocalhost: boolean;
  
  /** Whether the translation override is allowed */
  isTranslationOverrideAllowed: boolean;
}

/**
 * Determines whether new phrases should be allowed to be sent to Localize.
 * Based on the environment and user settings.
 * For numbered environments and localhost, it relies on the isTranslationOverrideAllowed feature flag.
 * For non-numbered environments (Dev, Staging, Prod), it always returns true.
*/
export function shouldEnableSaveNewPhrases({
  isNumberedDevEnvironment,
  isLocalhost,
  isTranslationOverrideAllowed,
}: SaveNewPhrasesParams): boolean {

  // For all numbered environments or localhost rely on the isTranslationOverrideAllowed flag value
  if (isNumberedDevEnvironment || isLocalhost) {
    return isTranslationOverrideAllowed;
  }

  // Always return true for non-numbered environments in dev, staging and prod
  return true;
}